import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpInterceptor } from './httpInterceptor.service';

@Injectable({
    providedIn: 'root'
})
export class PersonalDetailsCall {

    constructor(
        private _httpInterceptor: HttpInterceptor
    ) { }
    public PostCallService(data, value?) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.personalDetailsCall;
        url = url.replace('{applicationId}', data.urlData.applicationId);
        url = url.replace('{quoteId}', data.urlData.quoteId);
        url = url.replace('{personCode}', data.urlData.personCode);
        return this._httpInterceptor.applicationTokensPost(url, { action: value, payload: data.payload });
    }
    public GetCallService(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.personalDetailsCall;
        url = url.replace('{applicationId}', data.applicationId);
        url = url.replace('{quoteId}', data.quoteId);
        url = url.replace('{personCode}', data.personCode);
        return this._httpInterceptor.Get(url);
    }
    public GetAddressDetails(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.mailingAddressService;
        url = url.replace('{applicationId}', data.applicationId);
        url = url.replace('{quoteId}', data.quoteId && data.quoteId !== 'null' ? data.quoteId : 0);
        url = url.replace('{addressCode}', data.addressCode);
        return this._httpInterceptor.Get(url);
    }
    public GetSummaryService(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.getSummaryDetails;
        url = url.replace('{applicationId}', data.applicationId);
        url = url.replace('{quoteId}', data.quoteId);
        return this._httpInterceptor.Get(url);
    }
    public GetSalutationService(key) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.salutationDetails;
        url = url.replace('{principalKey}', key);
        return this._httpInterceptor.Get(url);
    }

    public GetMaritalStatusService(key) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.maritalStatusDetails;
        url = url.replace('{principalKey}', key);
        return this._httpInterceptor.Get(url);
    }

    public GetDesignationService() {
        let url = ConfigService.getInstance().getConfigObject().APIURL.designationDetails;
        return this._httpInterceptor.Get(url);
    }

    public GetEducationService() {
        let url = ConfigService.getInstance().getConfigObject().APIURL.educationDetails;
        return this._httpInterceptor.Get(url);
    }

    public GetOccupationService() {
        let url = ConfigService.getInstance().getConfigObject().APIURL.occupationDetails;
        return this._httpInterceptor.Get(url);
    }

    public getOccupation(principalId: any, productCategoryId: any): Observable<any> {
        let url = ConfigService.getInstance()
            .getConfigObject().APIURL.getOccupation;
        url = url.replace('{principalKey}', principalId);
        url = url.replace('{productCategoryKey}', productCategoryId);
        return this._httpInterceptor.Get(url, true);
    }

    //For loading mock json (To be removed later)
    public getMockService() {
        return this._httpInterceptor.Get('assets/MockJson/getproposer.json');
    }
    public postMockService() {
        return this._httpInterceptor.Get('assets/MockJson/postproposerResp.json');
    }
    public postMockBackService() {
        return this._httpInterceptor.Get('assets/MockJson/postproposerBack.json');
    }
    public getSummaryMockService() {
        return this._httpInterceptor.Get('assets/MockJson/GetSummaryMock.json');
    }
}
